import DailyAllowances from '../util/billing_items/daily_allowances'

up.compiler('[billing-item-daily-allowances]', (element) => {
  const form = element.closest('form')

  const dailyAllowancesBillingItem = new DailyAllowances(element)

  form.addEventListener('submit', function(event) {
    if (!dailyAllowancesBillingItem.isValid()) {
      event.preventDefault()
    }
  })
})
